import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
import { translation } from '../../../../../utils/helpers'
import { getRelativeDateTime } from '../../../../../utils/time'
import { formatCurrency } from '../../../../../utils/currency'
import { isiOS } from '../../../../../constants'
import { isTouchDevice } from '../../../../../utils/detect'

// Elements
import TableContainer from '../../../../elements/tableContainer'
import TableExpand from '../../../../elements/tableExpand'
import TableHeader from '../../../../elements/tableHeader'
import TableRow from '../../../../elements/tableRow'
import ArrowButton from '../../../../elements/arrowButton'
import Check from '../../../../elements/check'
import BottomBar from '../../../../elements/bottomBar'
import IconAccordion from '../../../../elements/iconAccordion'
import { SparePartModuleIcons, ProductionStatus, ButtonIcons, OrderTypeIcons } from '../../../../elements/icons'
import OverlayContent from '../../../../elements/overlayContent'
import Button from '../../../../elements/button'
import Label from '../../../../elements/label'
import Icon from '../../../../elements/icon'
import Inline from '../../../../elements/inline'
import Grid from '../../../../elements/grid'
import CheckButton from '../../../../elements/checkButton'

import OrderingSlidePanel from '../../orderingSlidePanel'
import FilterSlidePanel from '../../filterSlidePanel'

// Actions
import { getSparePartsOrdering, updateSparePartsOrdering } from '../../../../../actions/spareparts'
import { closeSlidePanel, openSlidePanel, isSlidePanelOpen, openOverlay } from '../../../../../actions/common'

import './ordering.scss'
import Radio from '../../../../elements/radio'

const UsedInStepType = {
  BodyShopRepair: 102,
  BodyShopAssemply: 103
}
class Ordering extends Component {
  constructor (props) {
    super(props)
    this.state = {
      spareParts: [],
      sparePartComments: [],
      groups: [],
      slidePanelId: 'sparePartsOrdering',
      selectedSpareParts: [],
      rowClicked: false,
      slidePanelView: '',
      filterPanelView: '',

      isLoading: false
    }

    this.groupData = this.groupData.bind(this)
    this.resetSelected = this.resetSelected.bind(this)
    this.renderGroup = this.renderGroup.bind(this)
    this.onDone = this.onDone.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.isDracarMatch = this.isDracarMatch.bind(this)
    this.fromDracar = this.fromDracar.bind(this)
    this.usesDracar = this.usesDracar.bind(this)
    this.usesDracarCreation = this.usesDracarCreation.bind(this)
    this.openOverlay = this.openOverlay.bind(this)
    this.getKeyLoopSystemName = this.getKeyLoopSystemName.bind(this)
  }

  componentDidMount () {
    this.setState({
      isLoading: true
    }, () => this.props.getSparePartsOrdering({ ...this.props.sparePartsFilter, OrderId: this.props.orderId }).then(res => {
      this.setState({ isLoading: false })
      this.handleErrors(res)
    }))
  }

  componentDidUpdate () {
    if (!isEqual(this.props.spareParts, this.state.spareParts)) {
      this.setState({
        spareParts: this.props.spareParts
      }, this.groupData)
    }
  }

  openSlidePanel (type, newState = {}) {
    this.setState({
      ...newState,
      slidePanelView: type
    }, () => {
      this.props.openSlidePanel(this.state.slidePanelId)
    })
  }

  openOverlay () {
    this.props.openOverlay('MatchingPartsOverlay')
  }

  resetSelected () {
    this.setState({
      selectedSpareParts: []
    })
  }

  onDone (type, sparePartNumber) {
    if (type === 'add') {
      let selected = this.props.spareParts.filter(sp => {
        return sparePartNumber === sp.OriginalSparePartNumber
      })
      this.setState({
        selectedSpareParts: selected,
        rowClicked: true,
        slidePanelView: 'status'
      })
      return
    }
    this.resetSelected()
  }

  usesDracar () {
    // We do not check if invoicing to Dracar is active, just that they are allowed and have it selected.
    return this.props.auth.permissions.DracarUsable
  }

  usesDracarCreation () {
    return this.props.auth.permissions.UseDracarSparePartCreation
  }

  fromDracar (status) {
    switch (status) {
      case 1001:
      case 2001:
        return true
      default:
        return false
    }
  }

  isDracarMatch (status) {
    switch (status) {
      case 2:
      case 4:
        return true
      default:
        return false
    }
  }

  groupData () {
    let spareParts = this.state.spareParts
    let currentGroups = this.state.groups
    let hasGroups = currentGroups.length > 0
    let groupData = []

    if (this.usesDracar()) {
      spareParts = spareParts.sort((a, b) => {
        const x = Number(a.Number)
        const y = Number(b.Number)

        if (x > y) return 1
        if (x < y) return -1
        return 0
      })

      groupData.push(
        {
          title: 17870,   // Added manually Non-matching
          items: spareParts.filter(x => !this.isDracarMatch(x.DracarStatus) && !this.fromDracar(x.DracarStatus) && Number(x.OrderSparePartId) === 0 && !x.RemovedFromReport),
          expand: hasGroups ? currentGroups[0].expand : true
        },
        {
          title: 17871,   // Added manually matching
          items: spareParts.filter(x => this.isDracarMatch(x.DracarStatus) && !this.fromDracar(x.DracarStatus) && Number(x.OrderSparePartId) === 0 && !x.RemovedFromReport),
          expand: hasGroups ? currentGroups[1].expand : true
        },
        {
          title: 17872,   // Non-matching
          items: spareParts.filter(x => !this.isDracarMatch(x.DracarStatus) && !this.fromDracar(x.DracarStatus) && Number(x.OrderSparePartId) > 0 && !x.RemovedFromReport),
          expand: hasGroups ? currentGroups[2].expand : true
        },
        {
          title: 16638,   // From [KeyLoopSystem]
          items: spareParts.filter(x => x.DracarStatus !== 3 && this.fromDracar(x.DracarStatus) && !x.RemovedFromReport),
          expand: hasGroups ? currentGroups[3].expand : true
        },
        {
          title: 17873,   // Matching
          items: spareParts.filter(x => this.isDracarMatch(x.DracarStatus) && !this.fromDracar(x.DracarStatus) && Number(x.OrderSparePartId) > 0 && !x.RemovedFromReport),
          expand: hasGroups ? currentGroups[4].expand : true
        }
      )
    }

    let groupNumber = this.usesDracar() ? 5 : 0
    groupData.push(
      {
        title: 16499,   // Removed from report
        items: spareParts.filter(x => x.RemovedFromReport),
        expand: hasGroups ? currentGroups[groupNumber].expand : true
      })
    //   {
    //     title: 16437,   // Added manually
    //     items: spareParts.filter(x => Number(x.OrderSparePartId) === 0 && !this.fromDracar(x.DracarStatus) && !x.RemovedFromReport),
    //     expand: hasGroups ? currentGroups[groupNumber + 1].expand : true
    //   }
    // )
    // if (!this.usesDracar()) {
    //   groupData.push(
    //     {
    //       title: 16438,   // From report
    //       items: spareParts.filter(x => Number(x.OrderSparePartId) > 0 && !x.RemovedFromReport),
    //       expand: hasGroups ? currentGroups[groupNumber + 2].expand : true
    //     }
    //   )
    // }

    if (!this.usesDracar()) {
      groupData.push(
        {
          title: 16437,   // Added manually
          items: spareParts.filter(x => Number(x.OrderSparePartId) === 0 && !x.RemovedFromReport),
          expand: hasGroups ? currentGroups[groupNumber + 1].expand : true
        },
        {
          title: 16438,   // From report
          items: spareParts.filter(x => Number(x.OrderSparePartId) > 0 && !x.RemovedFromReport),
          expand: hasGroups ? currentGroups[groupNumber + 2].expand : true
        }
      )
    }
    // else {
    //   groupData.push(
    //     {
    //       title: 16438,
    //       items: spareParts.filter(x => Number(x.OrderSparePartId) > 0 && !x.RemovedFromReport),
    //       expand: hasGroups ? currentGroups[groupNumber + 1].expand : true
    //     }
    //   )
    // }

    this.setState({ groups: groupData })
  }

  getStatusIcons (row, isHeader = false) {
    let statusIcons = [ { icon: SparePartModuleIcons.Warning, noCircle: true } ]
    if (row.Handled === row.Count) {
      statusIcons = [ { icon: SparePartModuleIcons.OK, noCircle: true } ]
    }

    if (row.Pickup) {
      statusIcons.push({ icon: SparePartModuleIcons.Pickup })
    }
    if (isHeader && row.RequiresPaint) {
      statusIcons.push({ icon: SparePartModuleIcons.Coating })
    }
    if (isHeader && row.UrgentDelivery) {
      statusIcons.push({ icon: SparePartModuleIcons.Urgent })
    }
    if (isHeader && row.UsedInStep) {
      switch (row.UsedInStep) {
        case UsedInStepType.BodyShopAssemply:
          statusIcons.push({ icon: ProductionStatus.Step_BodyShopAssembly })
          break
        case UsedInStepType.BodyShopRepair:
          statusIcons.push({ icon: ProductionStatus.Step_BodyShopRepair })
          break
      }
    }

    return statusIcons
  }

  getStatusInfo (row) {
    let statusIcons = this.getStatusIcons(row)

    const getStatusText = () => {
      // Has multiple statuses
      if ((row.Status & (row.Status - 1)) !== 0 || row.Suppliers.length > 1) {
        return 16514
      }

      switch (row.Status) {
        case 2:
          return 16449
        case 4:
          return 14799
        case 8:
          let name = ''
          let relativeDateTime = ''
          if (row.Suppliers.length > 0) {
            const supplier = row.Suppliers[0]
            name = supplier.Name
            relativeDateTime = getRelativeDateTime(supplier.DeliveryDate)
          }
          return [
            <div key={0}>{name}</div>,
            <div className='supplier__delivery' key={1}>{relativeDateTime}</div>
          ]
        case 1:
        default:
          return 15392
      }
    }

    return (
      <Grid cols={['100px', 'auto']} align='center'>
        <IconAccordion icons={statusIcons} />
        <Label>{getStatusText()}</Label>
      </Grid>
    )
  }

  handleErrors (err) {
    if (err) {
      if (err.data) {
        if (err.data.Errors !== undefined && err.data.Errors !== null && Array.isArray(err.data.Errors) && err.data.Errors.length > 0) {
          let errors = err.data.Errors
          let errText = ''
          for (let i = 0; i < errors.length; i++) {
            let dictKey = errors[i].DictionaryKey
            errText += '<br/>' + translation(dictKey)
          }
          window.toastr.error(translation(errText), translation('216'))
        }
      } else {
        window.toastr.error(err, translation('216'))
      }
    }
  }

  getKeyLoopSystemName () {
    switch (this.props.auth.accountingSystem) {
      case 4: return translation(15352)
      case 6: return translation(18138)
    }
    return ''
  }

  renderGroup (group, index) {
    const items = group.items
    let headerCols = '6.8fr 6.2fr 6fr'
    let cols = '1fr 1.5fr 4fr 1.5fr 2fr 5fr 2fr .5fr .5fr .5fr .5fr 32px'

    if (this.usesDracar()) {
      headerCols = '1fr 5.8fr 6.2fr 6fr'
    }

    if (items.length === 0) return null

    const isChecked = (item, isAll = false, isRow = false) => {
      if (isAll) {
        let validSpareParts = items.filter(x => x.Handled < x.Count)
        return validSpareParts.length > 0 && validSpareParts.every(v => this.state.selectedSpareParts.includes(v)) && !this.state.rowClicked
      }
      return this.state.selectedSpareParts.includes(item) && this.state.rowClicked === isRow
    }

    const onCheckChange = (e, item) => {
      if (item !== undefined) {
        let temp = e
        e = item
        item = temp
      }
      const { name, checked } = e.target
      let stateSpareParts = this.state.selectedSpareParts
      if (this.state.rowClicked) stateSpareParts = []

      if (name === 'all') {
        stateSpareParts = stateSpareParts.filter(x => !items.includes(x)) // Remove all from current group

        if (checked) {
          stateSpareParts = stateSpareParts.concat(items.filter(x => x.Handled < x.Count)) // add all from curentgroup exept those where all have a status
        }
      } else if (name === 'sparePart') {
        if (checked === true) {
          stateSpareParts = [...stateSpareParts, item] // Array.push() doesn't work here
        } else {
          stateSpareParts = stateSpareParts.filter(pt => pt !== item)
        }
      }
      if (stateSpareParts.length === 0 || this.state.rowClicked) this.props.closeSlidePanel(this.state.slidePanelId)
      this.setState({
        selectedSpareParts: stateSpareParts,
        rowClicked: false
      })
    }

    const renderRow = (row, index) => {
      const onClick = (type) => {
        if (!type) {
          // if all are ordered or have same status, show status view
          let multipleStatus = (row.Status & (row.Status - 1)) !== 0
          type = (row.status === 8 || (row.Count > 1 && multipleStatus)) ? 'listDetail' : 'status'
        }

        this.openSlidePanel(type, {
          selectedSpareParts: [ row ],
          rowClicked: true
        })
      }

      const updateSparePart = (e) => {
        let { name, checked, value, type } = e.target
        let val = checked
        if (type === 'radio') {
          name = name.substring(name.indexOf('.') + 1)
          val = value
        }

        const sparePartsBody = {
          OrderId: this.props.orderId,
          SpareParts: [ row ],
          [name]: val,
          Filter: this.props.sparePartsFilter
        }

        this.props.updateSparePartsOrdering(sparePartsBody).then(() => {
          // window.toastr.success(translation('16579'), translation('13424'))
        })
      }
      let disabled = this.state.selectedSpareParts.length > 0
      const partNumber = row.SparePartNumberAlias || row.OriginalSparePartNumber
      const searchNumber = row.Number ? row.Number : ''
      let partPrice = row.Price ? row.Price : 0.0
      let partCount = `${row.Handled} ${translation(16436)} ${row.Count}`
      let itemPrice = <span>{formatCurrency(partPrice)}</span>

      if (this.usesDracar()) {
        partCount = `${row.Handled}/${row.Count}`

        if (this.fromDracar(row.DracarStatus)) {
          partPrice = row.ListPrice
        }

        itemPrice = (
          <div className='amount'>{formatCurrency(partPrice)}
            {this.isDracarMatch(row.DracarStatus) && row.ListPrice > 0 ? (
              <div className='description__dracar__price'>
                {formatCurrency(row.ListPrice)}
              </div>
            ) : null}
          </div>
        )
      }

      const getQualityInfo = () => {
        let qualityInfo = ''
        switch (row.QualityType) {
          case 0:
            qualityInfo = translation(17850)
            break
          case 1:
            qualityInfo = translation(17851)
            break
          case 2:
            qualityInfo = translation(76)
            let subQualityInfo = ''
            switch (row.SubQualityType) {
              case 1:
                subQualityInfo = `, ${translation(17852)})`
                break
              case 2:
                subQualityInfo = `, ${translation(17853)})`
                break
              case 3:
                subQualityInfo = `, ${translation(17854)})`
                break
            }
            qualityInfo += subQualityInfo
            break
        }
        return (
          <span>{qualityInfo}</span>
        )
      }

      let uniqueId = index + '_' + row.InstanceId + '_' + row.OrderSparePartId
      return (
        <TableRow key={index} cols={cols} onClick={() => onClick()} selected={isChecked(row, false, true)}>
          <Check name='sparePart' value={partNumber} checked={isChecked(row)} onChange={onCheckChange.bind(this, row)} disabled={row.Handled === row.Count} simple />
          <span>{searchNumber}</span>
          <span>
            <div>
              {row.Description}
              <div className='description__partnumber'>
                {partNumber}
              </div>
            </div>
          </span>
          <span>{partCount}</span>
          {itemPrice}
          {this.getStatusInfo(row)}
          {getQualityInfo()}
          <Radio name={uniqueId + '.UsedInStep'} id={uniqueId + '.UsedInStepType.BodyShopRepair'} value={UsedInStepType.BodyShopRepair} checked={row.UsedInStep === UsedInStepType.BodyShopRepair} onChange={updateSparePart} />
          <Radio name={uniqueId + '.UsedInStep'} id={uniqueId + '.UsedInStepType.BodyShopAssemply'} value={UsedInStepType.BodyShopAssemply} checked={row.UsedInStep === UsedInStepType.BodyShopAssemply} onChange={updateSparePart} />
          <Check name='RequiresPaint' value={partNumber} checked={row.RequiresPaint} onChange={updateSparePart} disabled={disabled} simple />
          <Check name='UrgentDelivery' value={partNumber} checked={row.UrgentDelivery} onChange={updateSparePart} disabled={disabled || ((row.Status & 8) === 8)} simple />
          {row.Count > 1 ? <ArrowButton size='m' onClick={(e) => { e.stopPropagation(); onClick('listDetail') }} /> : <div />}
        </TableRow>
      )
    }

    let totalSpareparts = items.reduce((a, b) => a + b.Count, 0)
    let totalHandledSpareparts = items.reduce((a, b) => a + b.Handled, 0)
    let totalStatus = items.reduce((status, part) => {
      status.Handled += part.Handled
      status.Count += part.Count
      status.Pickup |= part.Pickup
      status.RequiresPaint |= part.RequiresPaint
      status.UrgentDelivery |= part.UrgentDelivery

      return status
    }, { Handled: 0, Count: 0 })
    let statusIcons = this.getStatusIcons(totalStatus, true)

    const onClick = (expand) => {
      let groups = this.state.groups
      groups[index].expand = expand

      this.setState({
        groups: groups
      })
    }

    const getTableIcon = (title) => {
      if (!this.usesDracar()) return null
      switch (title) {
        case 16611:
          return <Icon size='l' icon={SparePartModuleIcons.Warning} injectSvg />
        case 16595:
          return <Icon size='l' icon={SparePartModuleIcons.OK} injectSvg />
        default:
          return <span />
      }
    }

    let statusText = 13052
    let sparePartsAmountText = translation(16439).replace('[count]', totalHandledSpareparts).replace('[total]', totalSpareparts)
    if (this.usesDracar()) {
      statusText = 16644
      sparePartsAmountText = `${totalSpareparts} ${translation(14853).toLowerCase()}`
    }

    return (
      <div key={index}>
        <TableContainer /* key={index} */ fullWidth>
          <TableExpand expand={group.expand} onClick={onClick}>
            <TableHeader cols={headerCols}>
              {getTableIcon(group.title)}
              <span className=''>{translation(group.title).replace('[KeyLoopSystem]', this.getKeyLoopSystemName())}</span>
              <span>{sparePartsAmountText}</span>
              {!group.expand && <IconAccordion icons={statusIcons} />}
              {group.expand && <span />}
            </TableHeader>

            <TableRow header cols={cols}>
              <Check name='all' checked={isChecked(null, true)} onChange={onCheckChange} spacing={0} disabled={totalHandledSpareparts === totalSpareparts} simple />
              <span>{`${translation(906)} #`}</span>
              <span>{translation(1021)}</span>
              <span>{translation(16441)}</span>
              <span className={this.usesDracar() ? 'unitprice' : ''}>{translation(16642)}</span>
              <span>{translation(statusText)}</span>
              <span>{translation(17849)}</span>
              <Icon className='ordering__icon' icon={ProductionStatus.Step_BodyShopRepair} ariaText={translation('18095')} ariaPos='top' injectSvg />
              <Icon className='ordering__icon' icon={ProductionStatus.Step_BodyShopAssembly} ariaText={translation('18094')} ariaPos='top' injectSvg />
              <Icon className='ordering__icon' icon={SparePartModuleIcons.Coating} ariaText={translation('14829')} ariaPos='top' injectSvg />
              <Icon className='ordering__icon' icon={SparePartModuleIcons.Urgent} ariaText={translation('16578')} ariaPos='top' injectSvg />
              <div />
            </TableRow>

            {items.map(renderRow)}
          </TableExpand>
        </TableContainer>
      </div>
    )
  }

  renderActionHeader () {
    const { groups } = this.state
    let showMatchingButton = false
    let cols = [1]

    if (groups.length > 0) {
      // console.log('Groups: ', groups)

      if (this.usesDracar() && !this.usesDracarCreation()) {
        showMatchingButton = (groups[0].items.length > 0 || groups[1].items.length > 0) && (groups[2].items.length > 0 || groups[4].items.length > 0)
      } else if (this.usesDracar() && this.usesDracarCreation()) {
        showMatchingButton = groups[2].items.length > 0 && groups[3].items.length > 0
      } else {
        showMatchingButton = groups[1].items.length > 0 && groups[2].items.length > 0
        if (showMatchingButton) {
          cols.push(1)
        }
      }
    }

    const actionButtons = (
      <div className='action-buttons'>
        <Grid cols={cols}>
          {!this.usesDracarCreation() && (<Button size='s' spacing={0} style='link' onClick={() => this.openSlidePanel('add')}>
            <Inline spacing={0}>
              <Icon size={this.props.size} icon={ButtonIcons.Add_Plus_16} injectSvg />
              <Label>{translation(1208)}</Label>
            </Inline>
          </Button>)}
          {showMatchingButton ? (
            <Button size='s' spacing={0} style='link' onClick={this.openOverlay}>
              <Inline spacing={0}>
                <Icon size={this.props.size} icon={ButtonIcons.Add_Plus_16} injectSvg />
                <Label>{translation(16588)}</Label>
              </Inline>
            </Button>
          ) : null}
        </Grid>
      </div>
    )

    let pageTitle = 16442
    if (this.usesDracar()) {
      pageTitle = 16643
    }

    return (
      <div className='top renderActionHeader'>
        <span>{translation(pageTitle)}</span>
        {actionButtons}
      </div>
    )
  }

  renderFilterActions () {
    const onClick = (e) => {
      this.setState({
        filterPanelView: e.target.name
      }, () => this.props.openSlidePanel('sparePartsFilter'))
    }

    return (
      <Inline className='filter'>
        <div className='filter__title'>{translation('16659')}</div>
        <CheckButton name='supplier' onClick={onClick} checked={(this.props.sparePartsFilter.SelectedFilters & 2) === 2} labelText={translation('16657')} size='m' />
        <CheckButton name='status' onClick={onClick} checked={(this.props.sparePartsFilter.SelectedFilters & 1) === 1} labelText={translation('13052')} size='m' />
      </Inline>
    )
  }

  renderTableGroupsTitle () {
    if (!this.usesDracar() || this.state.isLoading) return null

    // Icon needs to be medium. Hence why PanelHeader isn't used.
    return (
      <div className='groups__title'>
        <div className='element-header'>
          <Inline fillChildNum={[1]} alignChildren='center' block>
            <Icon size='m' icon={OrderTypeIcons.Insurance_Black} />
            <h3>{translation(13360)}</h3>
          </Inline>
        </div>
      </div>
    )
  }

  render () {
    const hasSelectedSpareParts = this.state.selectedSpareParts.length > 1
    const filterOnClose = () => {
      this.setState({
        filterPanelView: ''
      })
    }

    // custom ios, ipad style to show the bottombar
    let iosCustomStyle = ''
    let isiPadPro = isTouchDevice() && /MacIntel/.test(navigator.platform)
    if (isiOS || isiPadPro) {
      iosCustomStyle = 'customIosStyle'
    }

    return (
      <div className='ordering'>
        <OverlayContent>
          {hasSelectedSpareParts && !this.props.isSlidePanelOpen(this.state.slidePanelId) && (
            <BottomBar
              cancelLabelText={translation(1155)}
              onCancelClick={this.resetSelected}
              className={iosCustomStyle}
            >
              <Button
                style={'secondary'}
                spacing={0}
                size='l'
                onClick={() => this.openSlidePanel('multiQuality')}
                labelText={translation(17849)}
              />
              <Button
                style={'secondary'}
                spacing={0}
                size='l'
                onClick={() => this.openSlidePanel('status')}
                labelText={translation(16448)}
              />
            </BottomBar>
            )}

          <div className='content'>
            {this.renderActionHeader()}
            {this.renderFilterActions()}

            {this.state.isLoading && (
              <div className='animated-background'>
                <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
                <span className='sr-only'>{translation('13382')}...</span>
              </div>
            )}
            {!this.state.isLoading && this.state.groups.map(this.renderGroup)}
          </div>
        </OverlayContent>

        <OrderingSlidePanel
          orderId={this.props.orderId}
          slidePanelId={this.state.slidePanelId}
          view={this.state.slidePanelView}
          selectedSpareParts={this.state.selectedSpareParts}
          onDone={this.onDone}
          isOpen={this.props.isSlidePanelOpen(this.state.slidePanelId)}
        />
        <FilterSlidePanel
          type='ordering'
          orderId={this.props.orderId}
          view={this.state.filterPanelView}
          filter={this.props.sparePartsFilter}
          onClose={filterOnClose.bind(this)}
        />
      </div>
    )
  }
}

Ordering.propTypes = {
  orderId: React.PropTypes.number.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    spareParts: state.spareParts.sparePartsOrdering,
    sparePartsFilter: state.spareParts.sparePartsFilterOrdering,
    slidePanelsLength: state.common.slidePanels.length, // Necessary for the isSlidePanelOpen check to function
    headerInfo: state.common.headerInfo // Contains information used to determine if the shop uses DRACAR
  }
}

export default connect(mapStateToProps, {
  getSparePartsOrdering,
  updateSparePartsOrdering,
  closeSlidePanel,
  openSlidePanel,
  isSlidePanelOpen,
  openOverlay
})(Ordering)



// WEBPACK FOOTER //
// ./src/app/shared/overlays/spareParts/tabs/ordering/index.js